import React from 'react';
import PropTypes from 'prop-types';
import exact from 'prop-types-exact';
import { connect } from 'react-redux';
import { compose } from 'recompose';
import {
  FormGroup,
  FormControl,
  Button,
} from 'react-bootstrap';
import { reduxForm, formPropTypes, Field, formValueSelector } from 'redux-form';

import { setFilteringValues } from '../actions';
import { createRenderer } from '../../reduxForm/utils';
import DistrictInput from '../../fields/DistrictInput';
import DepartmentInput from '../../fields/DepartmentInput';
import OperatorInput from '../../fields/OperatorInput';
import LeaseInput from '../../fields/LeaseInput';

const propTypes = exact({

  setFilteringValuesAction: PropTypes.func.isRequired,
  operator: PropTypes.object,

  ...formPropTypes,
});

const RenderInput = createRenderer((input, label, { disabled }) => {
  return (
    <FormControl type="input" {...input} />
  );
});

const RenderDistrictFilter = createRenderer((input, label, { disabled }) => {
  return (
    <DistrictInput {...input} />
  );
});

const RenderDepartmentFilter = createRenderer((input, label, { disabled }) => {
  return (
    <DepartmentInput {...input} />
  );
});

const RenderOperatorFilter = createRenderer((input, label, { disabled }) => {
  return (
    <OperatorInput {...input} />
  );
});

const RenderLeaseFilter = createRenderer((input, label, { disabled, operatorId, operator }) => {
  return (
    <LeaseInput
      disabled={disabled}
      operator={operator}
      operatorId={operatorId}
      allowCreate={false}
      {...input}
    />
  );
});

const returnDropDownValue = (selectedValue) => {
  if (!selectedValue) {
    return null;
  }
  if (selectedValue.name === 'None') {
    return null;
  }

  return selectedValue.id;
};

const returnLookupResultValue = (selectedValue) => {
  if (!selectedValue) {
    return null;
  }

  return selectedValue.user_id;
};

const FilterTicketsPanel = (props) => {
  const { handleSubmit, submitting, pristine, operator, setFilteringValuesAction } = props;
  const formOperatorId = (operator) ? operator.id : null;


  const formSubmit = (values) => {
    const { district, department, lease, job_ticket_number: jobTicketNumber } = values;


    setFilteringValuesAction({
      leaseId: returnLookupResultValue(lease),
      operatorId: returnLookupResultValue(values.operator),
      districtId: returnDropDownValue(district),
      departmentId: returnDropDownValue(department),
      jobTicketNumber,
    });
  };

  return (
    <React.Fragment>
      <form onSubmit={handleSubmit(formSubmit)}>
        <FormGroup>
          <Field
            name="job_ticket_number"
            type="text"
            label="Job or Ticket Number"
            component={RenderInput}
          />
        </FormGroup>
        <FormGroup>
          <Field
            name="district"
            label="District"
            component={RenderDistrictFilter}
          />
        </FormGroup>
        <FormGroup>
          <Field
            name="department"
            label="Department"
            component={RenderDepartmentFilter}
          />
        </FormGroup>
        <FormGroup>
          <Field
            name="operator"
            label="Operator"
            component={RenderOperatorFilter}
          />
        </FormGroup>
        <FormGroup>
          <Field
            name="lease"
            label="Lease"
            operator={operator}
            operatorId={formOperatorId}
            component={RenderLeaseFilter}
            disabled={!operator}
          />
        </FormGroup>
        <Button
          bsStyle="primary"
          type="submit"
          disabled={submitting || pristine}
        >
          Submit
        </Button>
      </form>
    </React.Fragment>
  );
};


FilterTicketsPanel.propTypes = propTypes;


const withForm = reduxForm({
  form: 'FilterTicketForm',
  enableReinitialize: true,
});

const mapDispatchToProps = {
  setFilteringValuesAction: setFilteringValues,
};

const selector = formValueSelector('FilterTicketForm');

const formValues = connect((state) => {
  const operator = selector(state, 'operator');

  return {
    operator,
  };
}, mapDispatchToProps);


const enhance = compose(
  withForm,
  formValues,
);

export default enhance(FilterTicketsPanel);
